import { render, staticRenderFns } from "./RouterView.vue?vue&type=template&id=956b4a12&"
import script from "./RouterView.vue?vue&type=script&lang=js&"
export * from "./RouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports